const { createConstant } = require('../helpers')

const service = 'file-service'

module.exports = {
  // For Admin Panel
  GET_FILE_ADMIN: createConstant(service, 'GET_FILE_ADMIN'),
  GET_FILE_ADMIN_SUCCESS: createConstant(service, 'GET_FILE_ADMIN_SUCCESS'),
  GET_FILE_ADMIN_ERROR: createConstant(service, 'GET_FILE_ADMIN_ERROR'),
  GET_FILE_ADMIN_RESET: createConstant(service, 'GET_FILE_ADMIN_RESET'),

  // For Admin Panel - Getting file and pushing into array
  GET_FILE_AND_APPEND_ADMIN: createConstant(service, 'GET_FILE_AND_APPEND_ADMIN'),
  GET_FILE_AND_APPEND_ADMIN_SUCCESS: createConstant(service, 'GET_FILE_AND_APPEND_ADMIN_SUCCESS'),
  GET_FILE_AND_APPEND_ADMIN_ERROR: createConstant(service, 'GET_FILE_AND_APPEND_ADMIN_ERROR'),
  GET_FILE_AND_APPEND_ADMIN_RESET: createConstant(service, 'GET_FILE_AND_APPEND_ADMIN_RESET'),

  // For Users - Getting file and pushing into array
  GET_FILE_AND_APPEND_USER: createConstant(service, 'GET_FILE_AND_APPEND_USER'),
  GET_FILE_AND_APPEND_USER_SUCCESS: createConstant(service, 'GET_FILE_AND_APPEND_USER_SUCCESS'),
  GET_FILE_AND_APPEND_USER_ERROR: createConstant(service, 'GET_FILE_AND_APPEND_USER_ERROR'),
  GET_FILE_AND_APPEND_USER_RESET: createConstant(service, 'GET_FILE_AND_APPEND_USER_RESET'),

  // For Admin Panel
  GET_FILES_URL_ADMIN: createConstant(service, 'GET_FILES_URL_ADMIN'),
  GET_FILES_URL_ADMIN_SUCCESS: createConstant(service, 'GET_FILES_URL_ADMIN_SUCCESS'),
  GET_FILES_URL_ADMIN_ERROR: createConstant(service, 'GET_FILES_URL_ADMIN_ERROR'),
  GET_FILES_URL_ADMIN_RESET: createConstant(service, 'GET_FILES_URL_ADMIN_RESET'),

  // For Admin Panel
  UPLOAD_FILES_ADMIN: createConstant(service, 'UPLOAD_FILES_ADMIN'),
  UPLOAD_FILES_ADMIN_SUCCESS: createConstant(service, 'UPLOAD_FILES_ADMIN_SUCCESS'),
  UPLOAD_FILES_ADMIN_ERROR: createConstant(service, 'UPLOAD_FILES_ADMIN_ERROR'),
  UPLOAD_FILES_ADMIN_RESET: createConstant(service, 'UPLOAD_FILES_ADMIN_RESET'),

  GET_FILE: createConstant(service, 'GET_FILE'),
  GET_FILE_SUCCESS: createConstant(service, 'GET_FILE_SUCCESS'),
  GET_FILE_ERROR: createConstant(service, 'GET_FILE_ERROR'),
  GET_FILE_RESET: createConstant(service, 'GET_FILE_RESET'),

  // Use-case -> when needs to get file on multiple places in same component
  GET_FILE_TWO: createConstant(service, 'GET_FILE_TWO'),
  GET_FILE_TWO_SUCCESS: createConstant(service, 'GET_FILE_TWO_SUCCESS'),
  GET_FILE_TWO_ERROR: createConstant(service, 'GET_FILE_TWO_ERROR'),
  GET_FILE_TWO_RESET: createConstant(service, 'GET_FILE_TWO_RESET'),

  GET_MULTIPLE_FILE: createConstant(service, 'GET_MULTIPLE_FILE'),
  GET_MULTIPLE_FILE_SUCCESS: createConstant(service, 'GET_MULTIPLE_FILE_SUCCESS'),
  GET_MULTIPLE_FILE_ERROR: createConstant(service, 'GET_MULTIPLE_FILE_ERROR'),
  GET_MULTIPLE_FILE_RESET: createConstant(service, 'GET_MULTIPLE_FILE_RESET'),

  GET_FILES_URL: createConstant(service, 'GET_FILES_URL'),
  GET_FILES_URL_SUCCESS: createConstant(service, 'GET_FILES_URL_SUCCESS'),
  GET_FILES_URL_ERROR: createConstant(service, 'GET_FILES_URL_ERROR'),
  GET_FILES_URL_RESET: createConstant(service, 'GET_FILES_URL_RESET'),

  UPLOAD_FILES: createConstant(service, 'UPLOAD_FILES'),
  UPLOAD_FILES_SUCCESS: createConstant(service, 'UPLOAD_FILES_SUCCESS'),
  UPLOAD_FILES_ERROR: createConstant(service, 'UPLOAD_FILES_ERROR'),
  UPLOAD_FILES_RESET: createConstant(service, 'UPLOAD_FILES_RESET'),

  GET_REFERRAL_FILE: createConstant(service, 'GET_REFERRAL_FILE'),
  GET_REFERRAL_FILE_SUCCESS: createConstant(service, 'GET_REFERRAL_FILE_SUCCESS'),
  GET_REFERRAL_FILE_ERROR: createConstant(service, 'GET_REFERRAL_FILE_ERROR'),
  GET_REFERRAL_FILE_RESET: createConstant(service, 'GET_REFERRAL_FILE_RESET'),

  GET_MC_FILE: createConstant(service, 'GET_MC_FILE'),
  GET_MC_FILE_SUCCESS: createConstant(service, 'GET_MC_FILE_SUCCESS'),
  GET_MC_FILE_ERROR: createConstant(service, 'GET_MC_FILE_ERROR'),
  GET_MC_FILE_RESET: createConstant(service, 'GET_MC_FILE_RESET'),

  GET_PRESCRIPTION_FILE: createConstant(service, 'GET_PRESCRIPTION_FILE'),
  GET_PRESCRIPTION_FILE_SUCCESS: createConstant(service, 'GET_PRESCRIPTION_FILE_SUCCESS'),
  GET_PRESCRIPTION_FILE_ERROR: createConstant(service, 'GET_PRESCRIPTION_FILE_ERROR'),
  GET_PRESCRIPTION_FILE_RESET: createConstant(service, 'GET_PRESCRIPTION_FILE_RESET'),
}
